export enum SubscriptionIntervalEnum {
  Monthly = 'monthly',
  Yearly = 'yearly',
}
